<template>
  <div class="page-wrapper">
    <div class="page-header"></div>
    <div class="page-body">
      <Email v-if="selected_view == 'emails'" @switchPage="switchPage"></Email>
      <Notification v-if="selected_view == 'notifications'" @switchPage="switchPage"></Notification>
      <Questionnaire v-if="selected_view == 'questionnaires'" @switchPage="switchPage"></Questionnaire>
    </div>
  </div>
</template>
<script>
import Email from "./Email/index.vue";
import Questionnaire from "./Questionnaire/index.vue"
import Notification from "./Notification/index.vue"
export default {
  components: {
    Email,
    Questionnaire,
    Notification
  },
  data: () => ({
    selected_view: "emails",
  }),
  watch: {
    "$route.params.tab"(val) {
      let vm = this;
      if (val) {
        vm.selected_view = val;
      } else {
        vm.selected_view = "emails";
      }
    },
  },
  mounted() { },
  created() { },
  methods: {
    switchPage(page) {
      let vm = this;
      vm.selectMenu(page.value)
    },
    selectMenu(tab) {
      let vm = this;
      vm.selected_view = tab;
      vm.$router.push({
        name: "communications",
        query: { tab: tab },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f6f6f6;
  padding: 5px;
  position: relative;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    display: flex;
    justify-content: space-between;
  }
}
</style>
